import React, { useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form';
import { ToastError, ToastSuccess } from 'src/components/uiElements/toast';
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
  GenerateOTP as GENERATE_OTP,
  VerifyOTP as Verify_OTP,
} from "src/components/api/user/user";

type PersonalDetailProps = {  
  FirstName: string;
  LastName: string;
  FirmName: string;
  MobileNumber: string;
  EmailID: string;
  OTP?: string | null;
};


const UseSignUp = () => {
  const [isSignInOpen, setIsSignInOpen] = useState(false);
  const [isSignUpOpen, setIsSignUpOpen] = useState(true);
  const [isRegiSuccess, setIsRegiSuccess] = useState(false);
  const [IsSignUp, setIsSignUp] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isVerifyOtpOpen, setIsVerifyOtpOpen] = useState(false);
const [isVerifyOtpScreenOpen, setIsVerifyOtpScreenOpen] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [signupData, setSignupData] = useState<PersonalDetailProps | null>(null);
  const validationSchema = Yup.object().shape({
    MobileNumber: Yup.string()
      .required("Mobile number is required")
      .min(10, "Mobile number must be 10 digits")
      .max(10, "Mobile number must be 10 digits"),
      // EmailID: Yup.string()
      // .required("Email ID is required")
      // .email("Invalid email format"),
      OTP: Yup.string().nullable(),     // OTP is now optional
  });

  const defaultValues = {
    FirstName: "",
    LastName: "",
    FirmName: "",
    MobileNumber: "",
    EmailID: "",
    OTP: "",
  };

  const formContext = useForm<PersonalDetailProps>({
    defaultValues,
    resolver: yupResolver(validationSchema) as any, // Explicitly cast to any
  });

  const onSubmit: SubmitHandler<PersonalDetailProps> = async (values) => {
    let inputObj = {
      FirstName: values.FirstName,
      LastName: values.LastName,
      FirmName: values.FirmName,
      MobileNumber: values.MobileNumber,
      EmailID: values.EmailID,
      OTP: values.OTP,
    };
    const request = JSON.stringify(inputObj);
    setLoading(true);

    if (isUpdate === false) {
      setMobileNumber(values.MobileNumber); // Store mobile number
      setSignupData(values); // Store full data
      const response = await GENERATE_OTP(request);
      setLoading(false);

      if (!response?.status) {
        let failResult;
        try {
          failResult = JSON.parse(response?.data!);
        } catch (e) {
          failResult = { Message: response?.data };
        }
        ToastError(failResult.Message);
        return;
      }
      let result;
      try {
        result = JSON.parse(response?.data!);
      } catch (e) {
        result = { Message: response?.data };
      }
      setIsUpdate(true);
      ToastSuccess(result.Message);
      setIsSignUpOpen(false);
      setIsVerifyOtpScreenOpen(true)
    } 
    // else {
    //   const response = await Verify_OTP(request);
    //   setLoading(false);

    //   if (!response?.status) {
    //     const failResult = JSON.parse(response?.data!);
    //     ToastError(failResult.Message);
    //     return;
    //   }
    //   const result = JSON.parse(response?.data!);
    //   ToastSuccess(result.Message);
    //   setIsSignUpOpen(false);
    //   setIsSignUp(false);
    //   //setIsRegiSuccess(true);
    // }
  };

  return {
    loading,
    setLoading,
    onSubmit,
    formContext,
    IsSignUp,
    isVerifyOtpOpen,
    setIsVerifyOtpOpen,
    isUpdate,
    isSignUpOpen,
    setIsSignUpOpen,
    isRegiSuccess,
    setIsRegiSuccess,
    setIsSignUp,
    setIsSignInOpen,
    isSignInOpen,
    isVerifyOtpScreenOpen,
    setIsVerifyOtpScreenOpen,
    mobileNumber,
    signupData,
  }
}


export default UseSignUp;